import React, { useContext, useEffect, useRef, useState } from "react";
import classes from "./Drinks.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { t } from "../../locales/i18n";
import Header from "../../components/Header/Header";
import { Helmet } from "react-helmet";
import BookNowBtn from "../../components/BookNowBtn";
import FooterInfo from "../../components/FooterInfo/FooterInfo";
import FloatingButton from "../../components/FloatingButton/FloatingButton";
import { ReactPhotoCollage } from "react-photo-collage";
import { images } from "../../assets/img";
import useCheckIsMobile from "../../hook/useCheckIsMobile";
import { DRINKS_MENU } from "../../utils/Const";

const AboutUs = () => {
  const navigate = useNavigate();
  const isMobile = useCheckIsMobile();

  return (
    <div className={classes.container}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"Drinks"}</title>
        <meta name="drinks" content="Drinks" />
      </Helmet>
      <Header selected={"drinks"} />

      <div className={classes.wrapper}>
        {DRINKS_MENU.map((categoryItem, index) => {
          return (
            <div key={index} className={classes.categoryContainer}>
              <div className={classes.categoryHeader}>
                <h1>{categoryItem?.category}</h1>
              </div>

              {categoryItem?.drinkList.map((drinkItem, index) => {
                return (
                  <div key={index} className={classes.drinkItem}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <h2>{drinkItem?.name}</h2>
                      <hr
                        style={{
                          flex: 1, 
                          height: "1px",
                          backgroundColor: "#c3c3c3",
                          border: "none",
                          margin: "0 1rem",
                        }}
                      />
                      <h2>Free</h2>
                    </div>
                    <p>{drinkItem?.ingredients}</p>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>

      <FooterInfo style={classes.footerStyle} />
      <FloatingButton />
    </div>
  );
};

export default AboutUs;
